function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m61 12h-15v-1h-.009a.991.991 0 0 0 -.284-.707l-8-8a.99.99 0 0 0 -.707-.283v-.01h-26a1 1 0 0 0 -1 1v9h-7a1 1 0 0 0 -1 1v38a1 1 0 0 0 1 1h26v4h-6a1 1 0 0 0 -.707.293l-4 4a1 1 0 0 0 .707 1.707h26a1 1 0 0 0 .707-1.707l-4-4a1 1 0 0 0 -.707-.293h-6v-4h26a1 1 0 0 0 1-1v-38a1 1 0 0 0 -1-1zm-1 2v10h-2v-7a1 1 0 0 0 -1-1h-11v-2zm-14 4h10v6h-10zm-8-12.586 4.586 4.586h-4.586zm-26-1.414h24v7a1 1 0 0 0 1 1h7v12h-1a1 1 0 0 0 -1 1v21h-30zm-4 42v-28h2v28zm-4-32h6v2h-3a1 1 0 0 0 -1 1v30a1 1 0 0 0 1 1h35v2h-38zm38.586 46h-21.172l2-2h17.172zm-9.586-4h-2v-4h2zm27-6h-16v-24h16z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 24a8 8 0 1 0 -8-8 8.009 8.009 0 0 0 8 8zm5.91-9h-4.91v-4.91a6.008 6.008 0 0 1 4.91 4.91zm-6.91-4.91v5.91a1 1 0 0 0 1 1h5.91a6 6 0 1 1 -6.91-6.91z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 26h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 26h22v2h-22z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 30h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 30h22v2h-22z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 34h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 34h22v2h-22z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 38h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 38h22v2h-22z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 42h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 42h22v2h-22z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 35h12a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1h-12a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1zm1-6h10v4h-10z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 42h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1zm1-4h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 36h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 49h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1zm1-4h2v2h-2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 43h-4a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-2v-2h2z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.c81131067784da22b1efa373f3dbef1e.svg";
export { ForwardRef as ReactComponent };